import * as React from 'react';

const TableBody: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <tbody>{children}</tbody>;
};

export { TableBody };
